/**
 * Проверяет все ли необходимые данные доп формы есть в заявке. Если хоть одного обязательного
 * поля нет, возвращает true.
 *
 * @param request объект заявки
 * @returns boolean
 */
export function isNeedExtData(request) {
    return !!request.nomination.extDataFields.find((field) => field.required && !request.extData[field.id]);
}
